globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.PasswordField = (function() {

  function PasswordField($input) {
    this.$input = $input;
    this.$formGroup = this.$input.closest('.form-group');

    this.init();
  }

  PasswordField.init = function($html) {
    $html.find('input[type=password]').each(function(){
      new PasswordField($(this));
    })
  }

  PasswordField.prototype = {
    init: function() {
      var _this = this;

      _this.$formGroup.addClass('has-feedback').on('click', '.form-control-feedback', function() {
        _this._toggleState();
      })

      _this._refreshState();
    },
    _toggleState: function(){
      this.$input.prop('type', this._isPasswordVisible() ? 'password' : 'text');
      this._refreshState();
    },
    _refreshState: function() {
      var $feedBack = this.$formGroup.find('.form-control-feedback');

      if($feedBack.length) {
        $feedBack.replaceWith(this._feedback());
      } else {
        this.$formGroup.append(this._feedback());
      }
    },
    _feedback: function(){
      return $('<div class="form-control-feedback cursor-pointer">').css({ pointerEvents: 'all' }).append(this._icon());
    },
    _icon: function(){
      return this._isPasswordVisible() ? this._iconHide() : this._iconShow();
    },
    _iconShow: function(){
      return $('<i class="icon-eye2"></i>');
    },
    _iconHide: function(){
      return $('<i class="icon-eye-blocked"></i>');
    },
    _isPasswordVisible: function(){
      return this.$input.prop('type') === 'text';
    }
  }

  return PasswordField;
})();
